import toArray from './../../scripts/to-array';
import { breakpoints } from '../../scripts/globals';

toArray(document.querySelectorAll('[data-component="video-hero"]')).forEach((component) => {
  const videoPreview = component.querySelector('[data-video-hero-video-preview]');
  const playerModal = component.querySelector('[data-video-hero-player]');
  const playerIframe = component.querySelector('[data-video-hero-iframe]');
  const button = component.querySelector('[data-video-hero-button]');

  function videoControl(action) {
    const playerWindow = playerIframe.contentWindow;
    playerWindow.postMessage(`{"event":"command","func":"${action}","args":""}`, '*');
  }

  button.addEventListener('click', (e) => {
    e.preventDefault();
    videoControl('playVideo');
    videoPreview.pause();
    playerModal.classList.add('video-hero__player-wrapper--active');
  });

  toArray(component.querySelectorAll('[data-video-hero-player-background], [data-video-hero-player-close] button')).forEach((closeButton) => {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      videoControl('stopVideo');
      if (window.innerWidth >= breakpoints.tablet) {
        videoPreview.play();
      }
      playerModal.classList.remove('video-hero__player-wrapper--active');
    });
  });
});
